import React, { Component } from 'react';
import PropTypes from 'prop-types'
import isEqual from 'react-fast-compare';

import { indexColorMapper, tensorFromMatrixData } from './utils';

import './DomGrid.css';

class DomGrid extends Component {
	constructor(props) {
		super(props);
		this.domgridRef = React.createRef();
	}
	shouldComponentUpdate(nextProps) {
		// only re-render this expensive component when the props have deeply changed
		const shouldUpdate = !isEqual(this.props, nextProps);
		return shouldUpdate;
	}
	onCellClick(coords) {
		const gridData = this.getGridData();
		const cellData = gridData.get(coords[0], coords[1], 0);
		const selectedCell = cellData ? coords : null;
		this.props.onCellClick(selectedCell);
	}
	getGridData() {
		return tensorFromMatrixData(this.props.currentMatrix).step(-1, 1);
	}
	renderGrid() {
		let gridData = this.getGridData();
		let timePeriod = this.props.timePeriod;
		let gridCells = gridData.tolist();
		// let gridHeight = gridData.shape[0];
		let gridWidth = gridData.shape[1];
		let gridColumns = gridWidth;

		console.log('grid info:', gridData)
		console.log('grid width:', gridWidth);

		let cellPadding;
		let cellHeight = (this.props.visibleHeight / gridWidth);
		// cellHeight = cellHeight * this.props.zoom; // instead of zooming by scaling up/down font-size, use transform
		
		if (gridWidth < 30) {
			cellHeight = cellHeight / 35; // convert from pixels to rem, 29.3 is a magic number for now
			cellPadding = 0.2;
		} else {
			cellHeight = cellHeight / 29.3; // convert from pixels to rem, 29.3 is a magic number for now
			cellPadding = 0.05;
		}

		document.documentElement.style.setProperty('--cell-height', `${cellHeight}rem`);
		document.documentElement.style.setProperty('--cell-padding', `${cellPadding}rem`);

		let grid = [];
		// let cellMargin = 0;
		// let cellWidth = 100 / gridColumns - cellMargin * 2 + '%';

		let rowStyle = {
			// display: "flex",
			// flexFlow: "row nowrap",
		};

		let headerRow = [];

		// build the empty top left cell
		headerRow.push(
			<div className="domgrid__header domgrid__cell" key='emptyheader' style={{ visibility: 'hidden' }}>
				{'****'}
			</div>
		);

		// build the y-axis of years
		for (let year = timePeriod[1]; year >= timePeriod[0]; year--) {
			headerRow.push(
				<div className="domgrid__header domgrid__y-axis domgrid__cell" key={year + 'header'}>
					{year}
				</div>
			);
		}

		// add y-axis to the grid
		grid.push(
			<div className="domgrid__col domgrid__cell" style={rowStyle} key={timePeriod}>
				{headerRow}
			</div>
		);
		
		let returnPeriod = this.props.highlightReturnsPeriod; //[10, 15]
		// let returnPeriod = this.props.highlightReturnPeriod.length ? this.props.highlightReturnPeriod:[0] //[10, 15]
		let returnCells = [];
		if (returnPeriod) {
			let startRow = gridColumns - returnPeriod[1];
			let endRow = gridColumns - returnPeriod[0];

			// Highlight return period
			for (let col = 0; col < gridColumns; col++) {
				for (let row = startRow; row < endRow; row++) {
					let coords = [ col, row - col ];
					let coordKey = coords[1] + ':' + coords[0];
					returnCells.push(coordKey);
				}
			}
		}

		let i = 0;
		
		for (let row = 0; row < gridColumns; row++) {
			
			let cols = [];
			let previousCellHadValue = true;
			const currentYear = timePeriod[0] + i;
		
			// add the x-axis header
			cols.push(
				<div className="domgrid__header domgrid__x-axis domgrid__cell" key={i + 'header'}>
					{currentYear}
				</div>
			);

			for (let col = 0; col < gridColumns; col++) {

				let cellValue = gridData.get(col, row, 0);
				let coords = [ col, row ];
				let coordKey = coords[0] + ':' + coords[1];
				let cellOverideData = gridCells[coordKey] ? gridCells[coordKey] : {};

				let colStyle = {
					background: indexColorMapper(
						[ cellValue ],
						JSON.stringify(returnPeriod) === JSON.stringify([ 0, 0 ]) ? 1 : 0.1
					)
				};

				if (this.props.selectedCell) {
					colStyle.background = indexColorMapper([ cellValue ], 0.1);
					let isCellSelected =
						this.props.selectedCell[0] === coords[0] && this.props.selectedCell[1] === coords[1];
					let isCellInlineSelected =
						cellValue !== 0 &&
						(this.props.selectedCell[0] === coords[0] || this.props.selectedCell[1] === coords[1]);
					colStyle.background = indexColorMapper([ cellValue ], 0.1);
					if (isCellInlineSelected) {
						colStyle.background = indexColorMapper([ cellValue ], 1);
					}
					if (isCellSelected) {
						colStyle.border = '1px solid black';
					}
				}
				if (returnCells.includes(coordKey)) {
					colStyle.background = indexColorMapper([ cellValue ], 1);
				}

				// we know we are at the end of a column when:
				// the current cell is 0 and the previous cell had a value
				if (!cellValue && previousCellHadValue) {
					previousCellHadValue = false;
					cols.push(
						<div className="domgrid__header domgrid__x-axis domgrid__cell" key={currentYear + 'header'}>
							{currentYear}
						</div>
					);		
				} else {
					// add returns value to each data cell
					cols.push(
						<div
							className="domgrid__cell"
							style={colStyle}
							key={col + 'd' + row + 'ff'}
							coords={coords}
							id={coordKey}
							onClick={this.onCellClick.bind(this, coords)}
							{...cellOverideData}
						>
							<div
								className="domgrid__cell-value"
								style={{
									visibility: this.props.showReturns && cellValue ? 'visible' : 'hidden'
								}}
							>
								{cellValue ? cellValue.toFixed(1) : '0'}
							</div>
						</div>
					);
				}

			}

			// TODO: add dates to the bottom of each column without them being hidden
			// most likely should go in the domgrid__cell above
			// cols.push(
			// 	<div className="domgrid__header domgrid__x-axis" key="footer">{timePeriod[0] + i}</div>
			// );

			// add x-axis columns to grid
			grid.push(
				<div className="domgrid__col" style={rowStyle} key={row}>
					{cols}
				</div>
			);
			
			i++;
		}
		return grid;
	}
	render() {
		const domgridStyles = {
			transform: `scale(${this.props.zoom})`
		}
		console.log('------ rendering')
		return (
			<div className="domgrid" style={domgridStyles}>
				{this.renderGrid()}
			</div>
		);
	}
}

DomGrid.propTypes = {
	currentMatrixId: PropTypes.string.isRequired,
	currentMatrix: PropTypes.any.isRequired, // TODO: define shape
	showReturns: PropTypes.any.isRequired, // TODO: define shape
	selectedCell: PropTypes.any, // TODO: define shape
	timePeriod: PropTypes.array.isRequired, // TODO: define shape
	highlightReturnsPeriod: PropTypes.any.isRequired,
	visibleHeight: PropTypes.number,
	zoom: PropTypes.number.isRequired,
	onCellClick: PropTypes.func.isRequired,
};

export default DomGrid;

